module.exports = __webpack_public_path__ + "img/apple-icon-144x144.b7c2c618.png";